/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForBackupConfiguration extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForBackupConfiguration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForBackupConfiguration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForBackupConfiguration>): BackgroundJobPayloadForBackupConfiguration {
        let obj = Object.assign(new BackgroundJobPayloadForBackupConfiguration(), model);
        BackgroundJobPayloadForBackupConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForBackupConfiguration>): BackgroundJobPayloadForBackupConfiguration {
        if (!model) return null;
        return BackgroundJobPayloadForBackupConfiguration.newInstance(<BackgroundJobPayloadForBackupConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForBackupConfiguration) {
        if (!obj) return;

        models.BackgroundJobPayloadForBackupConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForBackupConfiguration): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForBackupConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

}
